const newArea = {
  snackbar: "Ihr Update ist fertig",
  name: "Name der Firma",
  save: "Speichern",
  cancel: "Stornieren",
  area: "Unternehmen",
  formTitle: "Neue Firma",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newArea;
